function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawByMyCar = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 990.32 727.03",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 654.16,
    y1: 770.88,
    x2: 654.16,
    y2: 513.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M71.62 291.75c20.84 47.07-5.75 101.29-37 142.16-10.48 13.68-22 28-23.47 45.22-1.75 21 12.47 40.31 29.35 52.93 30.77 23 72.81 30.11 109.43 18.51 31.65-10 58.26-32.67 90.18-41.81 53.42-15.29 110 10.06 155.71 41.63 32.35 22.34 67 49.5 106 44.73 27.46-3.36 50.76-22.63 66.56-45.33 7.63-11 14.27-23.23 25.39-30.63 6.61-4.4 14.37-6.73 22.14-8.39 70.9-15.15 146.13 21.83 216.09 2.81 47.25-12.85 84.93-50.2 108.35-93.19s34.36-91.55 43.47-139.66c6.47-34.19 11.84-71.08-3-102.54-15.74-33.28-52.17-53.45-88.78-57.22s-73.34 6.68-107.07 21.42c-42.15 18.43-83.46 44.23-129.47 44.32-31.33.06-61.2-12-91.16-21.13-50.18-15.33-102.18-22.95-154.11-29.98-49.69-6.73-99.86-13-149.85-9-35.37 2.81-66.6 16.33-100.92 22.58-22.37 4.08-44.85 1-66.8 7.91-27 8.45-54.84 28.06-56.33 58.91-1.41 29.33 24.23 50.76 35.29 75.75z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("path", {
    d: "M697.89 183.16c-5 1.44-11.21 5.16-14.25 15.37-6 20 7.88 33.68 3.33 54.45a40.61 40.61 0 0 1-7 15.27c-5.57 7.55-11.63 11.13-17.49 16.42a52.18 52.18 0 0 0-15.37 25.24 69.86 69.86 0 0 0-.69 32.81c2.09 9.06 5.65 15.65 8.75 23a169.86 169.86 0 0 1 9 29 70.52 70.52 0 0 1 2 14.71c.1 6.23-.87 13-1.82 19.68l-8.47 59.11c-1.13 7.87-2.27 15.87-2.31 23.36-.06 8.65 1.33 16.08 2.71 23.33 3 15.64 6.17 31.87 13 40.12s18.41 5.39 25.54-11.45c6.78-16 6.92-37.4 12.9-54.52 9.42-27 28.16-30.6 38.55-56.33 10-24.68 6.92-55 12-83.12 3.62-20.17 11.33-38.57 15.9-58.5 6.57-28.71 5.92-58.51.67-80.57s-14.67-37.21-25.07-48.7c-4.41-4.87-9.12-9.2-14.66-9.63-5.89-.45-11 7-16.85 9.19-6.78 2.53-13.54-.18-20.37 1.76z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M729.78 173.61s-10 255.28-51.93 405.82M683.38 199.78s44.78 40.81 36.33 118.57M645.76 315.9s73.6 14.8 68.14 58.82M774.93 229.93s-29.77 26.07-56.31 99.91M745.82 453.1s-20.32 16-36.63-39.81M658.16 485.65s41.44-5.41 45.26-31.37",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), React.createElement("path", {
    d: "M798.06 11.94c-10.26 1.52-22.6 6.27-27.67 20.94-9.95 28.76 20.31 50.53 13.34 80.58-2.09 9-7.24 16.32-12.67 21.66-10.64 10.46-22.75 15-34.25 22.1s-23.44 18.24-28.83 35.35c-5.19 16.46-2.94 34.65 2.45 48.24s13.55 23.72 20.84 34.9a236.44 236.44 0 0 1 22.15 43.71c2.61 6.73 5 13.83 5.85 21.89.94 9.19-.25 19.08-1.43 28.76l-10.52 86c-1.4 11.45-2.81 23.1-2 34.13.91 12.73 4.67 23.83 8.38 34.67 8 23.38 16.56 47.67 31.63 60.62s38.75 10.12 51.49-13.84c12.13-22.81 9.9-54.26 20.24-78.76 16.3-38.61 54.65-41.73 73.1-78.38 17.71-35.16 7.8-80.14 14.91-121 5.1-29.28 18.89-55.45 26-84.26 10.2-41.51 5.33-85.46-8.17-118.57s-34.78-56.54-57.66-74.69c-9.7-7.69-20-14.64-31.48-15.92-12.24-1.36-22 8.94-33.79 11.53-13.7 3.07-28-1.72-41.91.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M862.92 1.64s9.65 374.76-59.36 591.47M769.99 34.68s97.62 65.42 89.26 178.92M705.91 201.23s154.08 30.52 148 94.69M963.04 89.94s-58.56 34.86-104.69 140.45M929.26 415.13s-40.16 21.14-80.53-63M751.63 452.68s85.13-3.06 90-40.82",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("ellipse", {
    cx: 488.21,
    cy: 584.71,
    rx: 427.67,
    ry: 41.08,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M67.25 535.81s8.38 11-3.87 27.5-22.35 30.52-18.22 40.83c0 0 18.48-30.73 33.52-31.16s5.12-18.69-11.43-37.17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M67.25 535.81a13.57 13.57 0 0 1 1.71 3.44c14.68 17.24 22.49 33.33 8.39 33.74-13.14.38-28.9 23.87-32.68 29.81a12.74 12.74 0 0 0 .45 1.35s18.48-30.73 33.52-31.16 5.16-18.7-11.39-37.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M82.83 549.78c0 3.86-.43 7-1 7s-1-3.13-1-7 .54-2 1.07-2 .93-1.86.93 2z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M88.16 554.38c-3.39 1.85-6.34 3-6.59 2.49s2.28-2.35 5.67-4.19 2.05-.5 2.31 0 2.01-.16-1.39 1.7z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M22.98 535.81s-8.38 11 3.87 27.5 22.31 30.52 18.31 40.83c0 0-18.48-30.73-33.52-31.16s-5.2-18.69 11.34-37.17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M22.98 535.81a13.57 13.57 0 0 0-1.71 3.44c-14.68 17.24-22.49 33.33-8.39 33.74 13.14.38 28.9 23.87 32.68 29.81a12.74 12.74 0 0 1-.45 1.35s-18.48-30.73-33.52-31.16-5.15-18.7 11.39-37.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M7.41 549.78c0 3.86.43 7 1 7s1-3.13 1-7-.54-2-1.07-2-.93-1.86-.93 2z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M2.06 554.38c3.39 1.85 6.34 3 6.59 2.49s-2.28-2.35-5.67-4.19-2.05-.5-2.31 0-2-.16 1.39 1.7z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M10.07 602.71s23.43-.72 30.49-5.75 36-11 37.79-3 35.21 40.11 8.76 40.32-61.46-4.12-68.51-8.41-8.53-23.16-8.53-23.16z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M87.59 631.52c-26.45.21-61.46-4.12-68.51-8.41-5.37-3.27-7.51-15-8.22-20.41h-.78s1.48 18.9 8.53 23.19 42.06 8.63 68.55 8.42c7.64-.06 10.27-2.78 10.13-6.8-1.13 2.43-4.02 3.95-9.7 4.01z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M315.03 450.95s117.25-74.91 198.31-74.91c0 0 97.59-15.2 203.74 10.49s145.36 59 174.79 49.22l-123.64 3.62z",
    fill: "#8cd0f3"
  }), React.createElement("path", {
    d: "M315.03 450.95s117.25-74.91 198.31-74.91c0 0 97.59-15.2 203.74 10.49s145.36 59 174.79 49.22l-123.64 3.62z",
    fill: "#8cd0f3",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#121c3f",
    d: "M867.68 565.6H152.6l19.66-78.77 121.6-32.33 573.82 15.08v96.02z"
  }), React.createElement("path", {
    d: "M905.32 516.38v25.14s-21.23 15.4-23.16 27.46c0 0-30.4 7.72-39.08 7.72-.79 0-1.65 0-2.55.09a72.18 72.18 0 0 0 3.17-11.19 73.7 73.7 0 1 0-144.56 0 73.57 73.57 0 0 0 4.69 15h-41.22s-.38.13-1 .4c-2.21 1-7.42 3.64-8.17 7.79H311.83l-7-.06a72.26 72.26 0 0 0 4-7.74 71.41 71.41 0 0 0 4.86-15.37 73.76 73.76 0 1 0-146.07-14.5 74.4 74.4 0 0 0 1.42 14.47 73.53 73.53 0 0 0 8.74 22.9c-4.88-1.19-15.53-4.57-15.53-4.57s-45.35-4.82-56.93-15l1.75-1.21 7.42-5.07-3.38-13a8 8 0 0 1-1-1.78c-.9-2.17-1.69-6.2 1.49-11.26 4.82-7.72 2.41-35.22 2.41-35.22s65.62-45.35 194.93-55.49c0 0 3.09 2.4 9.47 2.9 4.32.35 10.15-.18 17.56-2.9 0 0 10.61 4.82 56-21.23 0 0 77.21-53.08 178.54-48.24 0 0 104.22-6.28 193 28 38.26 14.76 67.37 22.63 88.12 26.79 19.16 3.85 31.19 4.56 36.7 4.62H891.86s0 11.49.61 25.06v.07c.22 4.72.52 9.69.94 14.52v.3c1.16 13.45 3.16 25.67 6.63 28.09z",
    fill: "#2856b8"
  }), React.createElement("path", {
    d: "M124.44 500.28s29.07-22.68 65.26-17.85c0 0-32.93 26.06-47.77 24.37l-2.53-2.17-15 .84s-2.24-3.5.04-5.19z",
    fill: "#8cd0f3"
  }), React.createElement("path", {
    d: "M152.66 539.52v13.39s-1 12.79-12.55 13.27l-33 1.63 7.41-5.07-3.38-13a7.73 7.73 0 0 1-1-1.77c3-2.76 10.07-7.42 24.45-8.42zM306.22 483.4l25.33-1s-10.25 8.08-17.49 8.81-7.84-7.81-7.84-7.81zM359.54 560.24s229.07-31.85 284.44-21.72c0 0 16.28 1.09 22.44 7.6s0 2.29 0 2.29z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M487.77 470.85s2.9-5.43 7.6-5.55l30.52-1.57s-.48 4.22-5.91 5.79zM664.37 461.68s2.9-5.43 7.6-5.55l30.52-1.61s-.48 4.22-5.91 5.79z",
    fill: "#18218a",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M560.16 387.28l-23.42 61.42-84.44.09h-75.52s11.28-8.28 29.45-18.83c6-3.5 12.81-7.24 20.2-11 6.8-3.48 14.12-7 21.81-10.34 6-2.64 12.32-5.18 18.78-7.55 29.29-10.71 62.21-17.9 93.14-13.79zM692.84 432.13s-35.28 5.23-68.95 9.1c-12.87 1.48-25.5 2.76-35.84 3.47l-1.44.1c-4 .26-7.71.43-10.86.49-5 .09-8.74-.13-10.61-.73l9.73-58.75s12 .13 29.75 1l3.88.21c3.69.21 7.58.45 11.64.73 5.8.4 11.91.88 18.21 1.46 30.42 2.79 64.88 7.8 86.7 16.82 46.43 19.22-32.21 26.1-32.21 26.1zM855.44 461.68v15.68s-25.33.36-19.9-4.7a77.61 77.61 0 0 0 9.53-11zM893.39 475.76l-20.57 1.61v-18.85s9.53-13.39 19.06 1.45l.55.87z",
    fill: "#8cd0f3"
  }), React.createElement("circle", {
    cx: 241.39,
    cy: 551.12,
    r: 58.87,
    fill: "#182a7c"
  }), React.createElement("path", {
    d: "M288.61 551.07a47.38 47.38 0 1 1-1-9.6 47.48 47.48 0 0 1 1 9.6z",
    fill: "#3f8ffe"
  }), React.createElement("ellipse", {
    cx: 241.32,
    cy: 551.06,
    rx: 40.59,
    ry: 40.69,
    fill: "#18218a",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M254.9 505.64v1.72l-13.51 44.73-10.84-47.19a47.49 47.49 0 0 1 24.35.74zM254.8 596.52a47.5 47.5 0 0 1-23.81.82l10.39-45.25zM288.61 551.07a47.48 47.48 0 0 1-2.26 14.54h-.19l-44.73-13.51 46.26-10.62a47.74 47.74 0 0 1 .92 9.59z",
    fill: "#3f8ffe"
  }), React.createElement("path", {
    d: "M241.39 552.09l-44.73 13.51h-.35a47.88 47.88 0 0 1-1.29-24.16z",
    fill: "#3f8ffe"
  }), React.createElement("circle", {
    cx: 241.32,
    cy: 551.06,
    r: 5.19,
    fill: "#182a7c"
  }), React.createElement("circle", {
    cx: 771.06,
    cy: 551.12,
    r: 58.87,
    fill: "#182a7c"
  }), React.createElement("path", {
    d: "M818.29 551.07a47.38 47.38 0 1 1-1-9.6 47.48 47.48 0 0 1 1 9.6z",
    fill: "#3f8ffe"
  }), React.createElement("ellipse", {
    cx: 771,
    cy: 551.06,
    rx: 40.59,
    ry: 40.69,
    fill: "#18218a",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M784.57 505.64v1.72l-13.51 44.73-10.84-47.19a47.49 47.49 0 0 1 24.35.74zM784.48 596.52a47.5 47.5 0 0 1-23.81.82l10.39-45.25z",
    fill: "#3f8ffe"
  }), React.createElement("path", {
    d: "M818.29 551.07a47.48 47.48 0 0 1-2.26 14.54h-.23l-44.74-13.52 46.26-10.62a47.74 47.74 0 0 1 .97 9.6zM771.06 552.09l-44.73 13.51h-.35a47.88 47.88 0 0 1-1.29-24.16z",
    fill: "#3f8ffe"
  }), React.createElement("circle", {
    cx: 771,
    cy: 551.06,
    r: 5.19,
    fill: "#182a7c"
  }), React.createElement("path", {
    d: "M426.44 419.02l-14.79 29.81H395.3l10.93-18.81c6.03-3.5 12.82-7.23 20.21-11zM467.02 401.13l-14.73 47.67h-21.74l17.7-40.14c6.04-2.62 12.32-5.14 18.77-7.53zM620.16 387.8l-32.09 56.91-1.44.1c-4 .26-7.71.43-10.86.49l28.87-58.43 3.88.21c3.64.2 7.56.44 11.64.72z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.2,
    d: "M377.34 448.63l-18.32 126.19 153.01-3.35 25.12-122.29-159.81-.55z"
  }), React.createElement("path", {
    d: "M661.62 580.96c-2.21 1-7.42 3.64-8.17 7.79H311.83l-7-.06a72.26 72.26 0 0 0 4-7.74z",
    fill: "#18218a",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M366.27 672.15c2.33-2.17 4.52-4.73 5.2-7.84s-.65-6.85-3.63-8c-3.33-1.28-6.9 1-9.6 3.37s-5.8 5-9.33 4.5a14.21 14.21 0 0 0 4.39-13.3 5.56 5.56 0 0 0-1.22-2.7c-1.85-2-5.21-1.13-7.42.43-7 5-9 14.53-9.05 23.15-.71-3.11-.11-6.35-.13-9.54s-.89-6.72-3.58-8.44a10.79 10.79 0 0 0-5.46-1.28c-3.17-.12-6.7.2-8.86 2.52-2.69 2.88-2 7.71.35 10.88s5.9 5.16 9.17 7.35a20.34 20.34 0 0 1 6.55 6.25 6.19 6.19 0 0 1 .49 1.12H354a55.36 55.36 0 0 0 12.27-8.47zM781.36 688.97a11.67 11.67 0 0 0 3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08 2.49s-4.28 3.69-6.89 3.32a10.48 10.48 0 0 0 3.24-9.81 4.1 4.1 0 0 0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8 8 0 0 0-4-.95c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.47 5.69.26 8s4.35 3.8 6.77 5.42a15 15 0 0 1 4.84 4.61 4.57 4.57 0 0 1 .36.82h14.65a40.83 40.83 0 0 0 9.04-6.27zM846.36 720.78a11.67 11.67 0 0 0 3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08 2.49s-4.28 3.69-6.89 3.32a10.48 10.48 0 0 0 3.24-9.81 4.1 4.1 0 0 0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8 8 0 0 0-4-.95c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.47 5.69.26 8s4.35 3.8 6.77 5.42a15 15 0 0 1 4.84 4.61 4.57 4.57 0 0 1 .36.82h14.65a40.83 40.83 0 0 0 9.04-6.27z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M763.27 740.41s-3.49 1.9-5.08-8.86c-1-7-3.91-21.43-5.82-30.8l-.24-1.19a16.27 16.27 0 0 0 1.61-.6s-11.12-43-8.58-52.52 0-26.58 0-26.58l-6.67-22.46s-16.52-5.7-22.87-7.28-24.14-12.66-24.14-12.66a13.72 13.72 0 0 1 .86 1.11l-.71-.43a26.51 26.51 0 0 1-3.5-4 25.18 25.18 0 0 0 6.58-13.68 28.4 28.4 0 0 0-1.42-28.89 14.17 14.17 0 0 0 2.43-4.54 7.42 7.42 0 0 0 .27-2.32 6.17 6.17 0 0 0-3.48-6.13 6.07 6.07 0 0 0-4.78.05c-1.41.64-2.52 1.84-4.06 2.16-2.57.53-4.77-1.53-6.79-3.06a20.43 20.43 0 0 0-10.79-4 10.48 10.48 0 0 0-5 .66 20.11 20.11 0 0 0-4.14 3.11c-4.58 3.69-11 4.72-16.75 6.73-1.1.38-2.32 1-2.52 2a1.46 1.46 0 0 0 0 .6 1.48 1.48 0 0 0 .06.76c-10.72 1.8-21.21 9.94-21.21 9.94l-1.76 1.63a3.36 3.36 0 0 0-3.67.31l-3.54 2.78a3.33 3.33 0 0 0-.8 4.34l-25.89 24-.56.52v-.09s-20 15.19-20 25.94c0 7.77 6 12.56 9.27 14.63a24.8 24.8 0 0 0-6.46 10V624.36l-.08.44v.18l-.05.3v.62l-.07.4-.09.5v.1l-.07.42v.2l-.08.46v.12l-.09.52v.23l-.23 1.31-.12.71v.12l-.13.73v.1l-.13.74v.06l-.14.78v.17l-.14.77v.17l-.13.76v.09l-.15.86v.16l-.34 1.92-.17 1v.15l-.17 1v.07l-.37 2v.17l-.18 1v.14l-.39 2.11v.09l-.2 1.07v.09l-.4 2.18v.14l-.2 1.08v.08l-.42 2.23v.12l-.21 1.1v.08l-.43 2.26v.09l-.21 1.1v.09L555.9 660v.1l-.22 1.09v.06l-.45 2.22v.06l-.22 1.08v.06l-.44 2.12v.09l-.21 1v.09l-.43 2v.07l-.21 1v.1l-.42 1.89v.05l-.2.89v.09q-.21.9-.41 1.74l-.2.82v.07q-.2.82-.39 1.57l-.19.72v.08l-.18.69c-.8 3-1.5 5-2 5.47a5.62 5.62 0 0 0-1.17 1.84l-.08.2-.08.22-.07.22-.33.3-.07.23-.06.21-.06.24v.22l-.05.24v.22q0 .24-.08.48v7.87l3 .91s1.51.83 3.84 1.91c-.33 10.09-1.26 23.75-3.79 32.11-5.64.29-19.57.88-22.09-.13-3.18-1.27-23.51-4.43-17.15 10.12 2.66 6.1 8.45 10.7 14.27 14a17.78 17.78 0 0 1-2.2.57c-5.18 1-6.62 2.73-6.42 4.51-.37 3 4.73 6.35 5.15 6.56.64.32 22.23 3.8 27.32 2.21s25.73-5.38 25.73-5.38v-.63s-.28-6.22-1.06-12.12c2.34-.34 4.89-.65 7.37-.84a10.06 10.06 0 0 0 5.44 6.95c13.66 7 18.11-2.53 18.11-2.53s18.47 3.55 28.79 1c1.08 1 2 1.71 2.65 2.19 3.35 2.41 12.37 4.06 22.46 4.18a31.83 31.83 0 0 0 8.06-.23 74.68 74.68 0 0 0 13.2-2.07c12.15-3.15 14.82-14.45 15.4-19.58.48-.14.82-.64 1-1.58a4.55 4.55 0 0 0 .42-1.63 48.1 48.1 0 0 1 1.3-6.88l15 .84c6.7 12.16 12.62 21.83 12.62 21.83l10.16-1.27a58.69 58.69 0 0 1-11.75-12.66c-5.08-7.59-5.08-44-5.08-44l.57-22.17v.23-1.07c.94 6.57 8.39 25.63 9.23 25.91.61.2 1.21.38 1.8.55l.54 1.42c4.24 11.24 15 40 15.76 44.54 1 5.7 40.66 7.91 49.55 5.06s-33.61-10.13-33.61-10.13zM621.6 614.49l-14.54 21.84c-5.22-9-10.66-17.28-15.58-22.76 12.9.43 27.77.89 30.12.92zm-2.21-56a3.37 3.37 0 0 0 3.51-.39l1.24-1a3.33 3.33 0 0 0 .85-4.28l.74-.73a110.58 110.58 0 0 0 15.12-3.67 28.23 28.23 0 0 0 3.7 12.84 25.06 25.06 0 0 0 2.44 7.2c-2.28-.19-4.76-.32-7.13-.3a37.24 37.24 0 0 0-6.19.39c-7.62 1.27-8.58 15.19-8.58 15.19s-15.31 5.38-24.51 5.57a11.52 11.52 0 0 1-3.44-.51l-.93-.06 1.25-3.42s-.54.17-1.43.35q.43-.65.9-1.32c5.82-8.35 15.9-19.11 22.46-25.84zm-31.46 168.95a59 59 0 0 0-3.15 6.2c-3.61.7-8.53 1.09-11.14-1.14a6.5 6.5 0 0 0-4.18-1.47l.06-.12c1.8-3.45 3.33-11.18 4.53-19.18 5.82 0 11.35-4.87 11.35-4.87l7.33 2.51.27.51.18.33.29.54.18.34.29.53.19.34.29.52.19.34.28.51.19.34.29.51.19.33.29.5.18.32.29.5.18.31.28.49.18.31.29.49.17.28.29.48.17.28.29.48.15.25.3.49.11.18c.52.85 1 1.66 1.49 2.42l.07.11.28.44.12.19.25.4.14.21.23.36.14.23.21.33.15.23.2.31.14.22.18.28.14.22.17.26.14.22.16.24.14.21a64.41 64.41 0 0 1-15.15.69z",
    transform: "translate(-104.84 -86.48)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M688.52 662.26c-8.67 2.79-47.38.62-48.31-5-.74-4.47-11.23-32.6-15.37-43.6l-1.66-4.4 20.13-4.34s.74 3.53 1.76 8.56c1.86 9.18 4.67 23.35 5.67 30.15 1.55 10.53 5 8.67 5 8.67s41.42 7.17 32.78 9.96zM579.16 479.52s-1.55 9.29 11.77 18 1.86 39.95 1.86 39.95l-9.85.55a24.21 24.21 0 0 1-25.46-21.92s5.57-9-4.65-32.21zM521.6 468.09s-19.17 18.69-28.08 31.57a45.49 45.49 0 0 0-2.89 4.66c-6.5 12.39-21.62-7.75-16.39-14.71l3.61-3.37 34.76-32.4s23.85-18.58 35.92-5.26-26.93 19.51-26.93 19.51z",
    fill: "#ffbdc6"
  }), React.createElement("circle", {
    cx: 564.18,
    cy: 463.29,
    r: 27.87,
    fill: "#a66477"
  }), React.createElement("path", {
    d: "M450.69 644.6s-20.75 1.24-23.85 0-22.91-4.33-16.68 9.92 29.73 20.13 29.73 20.13l17-4.34z",
    fill: "#7679b4"
  }), React.createElement("path", {
    d: "M450.69 644.6s-20.75 1.24-23.85 0-22.91-4.33-16.68 9.92 29.73 20.13 29.73 20.13l17-4.34z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M524.7 583.6l41.65 16.92 23.69 50.32s.31 17.65-15.17 21.68-37.16 2.17-42.74-1.86-28.49-27.87-28.49-27.87z",
    fill: "#7679b4"
  }), React.createElement("path", {
    d: "M521.87 583.6l36.05 13.51 20.51 40.27s.27 14.13-13.13 17.35-32.17 1.73-37-1.49-24.66-22.31-24.66-22.31z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M485.99 644.6s-10.84 3.72-15.17 0-12.08.93-12.08.93l3.42 20.13s15.48-3.41 23.85-2.48z",
    fill: "#ffbdc6"
  }), React.createElement("path", {
    d: "M485.99 644.6s-10.84 3.72-15.17 0-12.08.93-12.08.93l3.42 20.13s15.48-3.41 23.85-2.48z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M492.16 622.93l-9.89-3.41s-10.84 9.6-18 1.55 6.5-41.5 6.5-41.5l14.55-23.54 10.53 33.14 9.6 16.1z",
    fill: "#565388"
  }), React.createElement("path", {
    d: "M492.16 622.93l-9.89-3.41s-10.84 9.6-18 1.55 6.5-41.5 6.5-41.5l14.55-23.54 10.53 33.14 9.6 16.1z",
    opacity: 0.05
  }), React.createElement("path", {
    fill: "#565388",
    d: "M586.63 621.07l22.3 3.09 4.34 20.44-27.56-1.55.92-21.98z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M586.63 621.07l22.3 3.09 4.34 20.44-27.56-1.55.92-21.98z"
  }), React.createElement("path", {
    d: "M555.36 508.97s9.29 35.61 39 9.91l8.05 102.19s-9.91 15.79-11.46 30-28.49-44-44.59-44.28-32.05-22.76-32.05-22.76l18.12-37.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M555.67 508.04s9.29 35.61 39 9.91l8.05 102.19s-9.91 15.79-11.46 30-28.49-44-44.59-44.28-32.05-22.76-32.05-22.76l18.12-37.32z",
    fill: "#f2f1f2"
  }), React.createElement("path", {
    d: "M550.71 485.12s-13-2.17-20.44-.93-8.36 14.86-8.36 14.86-21.06 7.43-28.18 5c0 0-35-2.48-35 8.05s11.16 15.42 11.16 15.42 48.59 1.64 48.93 1.55c11.15-3.1-.31 0-.31 0l-20.13 30.35 18.58 25.7 19.82-14.55s2.48-13.63 9-20.44c4.64-4.87 10.71-26.79 13.8-38.92a19.9 19.9 0 0 0-2.25-15.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M493.52 499.66a45.49 45.49 0 0 0-2.89 4.66c-6.5 12.39-21.62-7.75-16.39-14.71l3.61-3.37c-1.32 15.98 11.69 14.28 15.67 13.42zM518.51 527.86h-.35s11.5-3.1.35 0z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M549.78 485.12s-13-2.17-20.44-.93-8.36 14.86-8.36 14.86-21.06 7.43-28.18 5l1.24-3.41s-18.88 5.88-16.72-13.97c0 0-19.51 14.86-19.51 25.39s11.15 15.46 11.15 15.46 48.59 1.64 48.93 1.55c11.15-3.1-.31 0-.31 0l-20.13 30.35 18.58 25.7 19.82-14.55s2.48-13.63 9-20.44c4.64-4.87 10.71-26.79 13.8-38.92a19.9 19.9 0 0 0-2.25-15.19z",
    fill: "#565388"
  }), React.createElement("path", {
    d: "M613.58 585.77v1.7a3.7 3.7 0 0 1 0-1.7zM645.07 613.52a35.39 35.39 0 0 1-20.23.18l-1.66-4.4 20.13-4.34s.73 3.56 1.76 8.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M584.78 492.86s17.34 10.84 23.54 12.39 22.3 7.12 22.3 7.12l6.5 22s2.48 16.72 0 26-25.7 26.94-24.46 24.15l-.62 24.46s0 35.61 5 43-9.45-7.28-9.45-7.28-17.5-25.86-19.66-42.27 1.23-79.53 1.23-79.53l-3.1-4.34s6.46-16.72-1.28-25.7z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M585.71 492.86s17.34 10.84 23.54 12.39 22.3 7.12 22.3 7.12l6.5 22s2.48 16.72 0 26 8.36 51.41 8.36 51.41-10 4.62-23.85 0c-.93-.31-10.22-24.46-9-27.25l-.62 24.46s0 35.61 5 43a57.35 57.35 0 0 0 11.46 12.39l-9.91 1.24s-28.52-46.72-30.69-63.1 1.24-79.59 1.24-79.59l-3.1-4.34s6.51-16.75-1.23-25.73z",
    fill: "#565388"
  }), React.createElement("path", {
    d: "M501.16 641.52s-20.75-30-19.82-44c0 0-2.48 19.2-5.26 20.44s-30.66-7.44-30.66-7.44-1.24-9 1.86-12.08 12.7-60.39 12.7-60.39 3.41-15.48 18.27-16.41 48.31 74.63 48.31 74.63 4.95 45.25-25.4 45.25z",
    fill: "#7679b4"
  }), React.createElement("path", {
    d: "M452.24 600.63s.62 43.35-7.12 50.48 22.61 10.84 22.61 10.84-5.26-10.53-.93-18.89 7.12-42.43 7.12-42.43z",
    fill: "#ffbdc6"
  }), React.createElement("path", {
    d: "M453.78 650.52s-3.1-7.74-11.46-1.55c0 0-7.43 17.34-20.44 19.82s-1.86 9.91-1.24 10.22 21.68 3.72 26.63 2.17 25.08-5.26 25.08-5.26-.93-20.44-4-22-1.56 9.27-14.57-3.4z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M453.78 651.11s-3.1-7.74-11.46-1.55c0 0-7.43 17.34-20.44 19.82s-1.86 9.91-1.24 10.22 21.68 3.72 26.63 2.17 25.09-5.25 25.09-5.25-.93-20.44-4-22-1.57 9.28-14.58-3.41z",
    fill: "#7679b4"
  }), React.createElement("path", {
    d: "M512.09 456.52a144.1 144.1 0 0 0 8.44 11.77 3.27 3.27 0 0 1-.47 4.7l-1.21.95a3.27 3.27 0 0 1-4.66-.65 36.93 36.93 0 0 0-10-9.47 3.27 3.27 0 0 1-.3-5.34l3.45-2.72a3.27 3.27 0 0 1 4.75.76z",
    fill: "#565388"
  }), React.createElement("path", {
    d: "M582.75 490.52c-4-5.63-3.24-10.09-3.24-10.09l-26.35 4.38a85 85 0 0 1 4.5 12.63 24.76 24.76 0 0 0 25.09-6.92z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 564.34,
    cy: 472.73,
    r: 24.77,
    fill: "#ffbdc6"
  }), React.createElement("path", {
    d: "M553.44 459.82c2.34-.39 4.42-1.76 6.79-1.88 3-.15 5.71 1.77 7.82 3.75s4.16 4.24 7.06 5.1a17.46 17.46 0 0 0 5.66.38 5.26 5.26 0 0 0 3-.76 3.78 3.78 0 0 0 1-1.53 14.55 14.55 0 0 0-.09-11.79 2 2 0 0 1-.28-1.28 1.94 1.94 0 0 1 .43-.71c2-2.36 4.11-4.72 4.92-7.58s-.18-6.38-3.13-7.65a5.89 5.89 0 0 0-4.66 0c-1.38.63-2.45 1.8-4 2.11-2.51.52-4.66-1.5-6.62-3a19.87 19.87 0 0 0-10.51-3.92 10.18 10.18 0 0 0-4.91.65 19.62 19.62 0 0 0-4 3c-4.47 3.61-10.73 4.62-16.33 6.59-1.07.38-2.26.94-2.46 2s1 2.13 2.2 2.59 2.58.76 3.38 1.69c1 1.2.68 2.9.86 4.41.37 3 3 4.63 5.91 5.5 2.41.77 5.57 2.73 7.96 2.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M553.44 459.2c2.34-.39 4.42-1.76 6.79-1.88 3-.15 5.71 1.77 7.82 3.75s4.16 4.24 7.06 5.1a17.46 17.46 0 0 0 5.66.38 5.26 5.26 0 0 0 3-.76 3.78 3.78 0 0 0 1-1.53 14.55 14.55 0 0 0-.09-11.79 2 2 0 0 1-.28-1.28 1.94 1.94 0 0 1 .43-.71c2-2.36 4.11-4.72 4.92-7.58s-.18-6.38-3.13-7.65a5.89 5.89 0 0 0-4.66 0c-1.38.63-2.45 1.8-4 2.11-2.51.52-4.66-1.5-6.62-3a19.87 19.87 0 0 0-10.37-3.84 10.18 10.18 0 0 0-4.91.65 19.62 19.62 0 0 0-4 3c-4.47 3.61-10.73 4.62-16.33 6.59-1.07.38-2.26.94-2.46 2s1 2.13 2.2 2.59 2.58.76 3.38 1.69c1 1.2.68 2.9.86 4.41.37 3 3 4.63 5.91 5.5 2.27.69 5.43 2.65 7.82 2.25z",
    fill: "#a66477"
  }), React.createElement("path", {
    d: "M533.45 578.36s17.69 3 22.11 12.55 31 35.39 31 35.39",
    opacity: 0.05
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M476.7 615.8c-2.79 1.24-30.66-7.43-30.66-7.43a29.59 29.59 0 0 1 .09-8.11c-1.6 3.86-.71 10.28-.71 10.28s27.87 8.67 30.66 7.43c.92-.41 1.81-2.79 2.59-5.8-.62 1.93-1.28 3.35-1.97 3.63zM460.56 536.15a18.25 18.25 0 0 0-.58 1.92s-6.72 40.13-10.73 55c3.71-12.07 10.71-53.35 11.31-56.92zM501.78 639.34s-20.75-30-19.82-44c0 0-.22 1.74-.61 4.2.94 14.64 19.81 41.98 19.81 41.98 14.43 0 20.88-10.22 23.67-20.95-3.08 9.88-9.59 18.77-23.05 18.77z"
  })), React.createElement("path", {
    d: "M448.33 611.43s18.92 10.42 25.74 5.46 2.48-12.7 2.48-12.7l-5.27-8.67h-17.65l-5.88 10.22zM577.35 652.35s1.24-24.77-30.35-24.46-1.24 0-1.24 0-12.39-3.72-27.87 5-33.14 6.81-33.14 6.81-14.25 23.54-.93 30.35 17.65-2.53 17.65-2.53 27.25 5.26 33.45-1.86a31.79 31.79 0 0 0 34.37 6.86s15.49-6.86 8.06-20.17z",
    fill: "#7679b4"
  }));
};

UndrawByMyCar.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawByMyCar;